/*
 Autogenerated via:

 SET group_concat_max_len = 200000;
 SELECT
 CONCAT(LOWER(LEFT(g.Name,1)),SUBSTRING(g.Name FROM 2), ': {nnone:0,n', -- groupName (camelCased)
 GROUP_CONCAT(CONCAT('t',
 CASE g.ID
 WHEN 119 THEN QUOTE(t.Name) -- timezone is truly special
 ELSE CONCAT(LOWER(LEFT(t.Name,1)),SUBSTRING(t.Name FROM 2)) -- typeName (camelCased)
 END,
 CASE t.Name
 WHEN 'Default' THEN '_'
 ELSE ''
 END, -- turn 'default' into 'default_'
 ':', t.ID)  -- separator and value :000000000
 ORDER BY t.Name SEPARATOR ',n'),
 'n},')
 FROM mtype t
 JOIN mtypegroup g ON t.mtypegroupid = g.id
 WHERE g.id != 0
 GROUP BY t.MTypeGroupID
 ORDER BY g.Name
 */
angular.module('trainerWebApp.consts').constant('mtypes', {
  accountStatus: {
    none:0,
    active:127000100,
    administrativeDisableDEPRECIATED:127000400,
    cancellationPending:127000600,
    cancelled:127000700,
    grace:127000300,
    grace2:127000800,
    nonPayment:127000200,
    trialExpired:127000500
  },
  actionType: {
    none:0,
    accidentalTrialistLogin:113047500,
    accountDeleted:113013900,
    accountDisabled:113007600,
    accountEnabled:113007700,
    accountHasBeenClosedEmailSent:113010400,
    accountInactivityFinalWarningEmailSent:113031710,
    accountInactivityFinalWarningEmailSent_OldRules:113031700,
    accountInactivityWarningEmailSent_OldRules:113016900,
    addedUserToCoursesAndSeriesFromManageUsersSidebar:113046100,
    administratorInvitationEmailSent:113042700,
    aggregateInvitationEmailSent:113012100,
    aggregateInvitationToSeriesEmailSent:113026100,
    anonymousCourseComplete:113013500,
    anonymousCourseStart:113013400,
    archiveUser:113043100,
    arrangeFrames:113000400,
    arrangerRecorderOpened:113035600,
    arrangeTabClicked:113035100,
    attemptChangeLengthNoncontiguousContent:113013600,
    billingDowngrade:113010902,
    billingPaidAccountCancellationPending:113010903,
    billingPaidAccountCancelled:113010905,
    billingResignup:113011000,
    billingSessionEnd:113045800,
    billingSessionStart:113045900,
    billingSignup:113010900,
    billingTrialExpired:113010904,
    billingUpgrade:113010901,
    buyNowButtonClicked:113010600,
    cancelledAccountInactivityFinalWarningEmailSent:113031720,
    cancelledAccountInactivityWarningEmailSent:113016920,
    catalogCourseEnroll: 113047800,
    cCFailedFirstTime:113010000,
    cCFailedFirstTimeEmailSent:113010200,
    cCFailedSecondTime:113010100,
    cCFailedSecondTimeEmailSent:113010300,
    changePassword:113002900,
    changeToGroupPermission:113044400,
    cJReportedLead:113034400,
    cJReportedPurchase:113034500,
    completionDeadlineDisabled:113016300,
    completionDeadlineUpdated:113016400,
    completionEmailSent:113004500,
    confirmOrderGoToDashboardLinkPressed:113019700,
    confirmOrderStartCourseButtonPressed:113019600,
    confirmPaymentInfoEditLinkPressed:113019400,
    confirmPaymentInfoPurchaseButtonPressed:113019500,
    conversionBegin:113001200,
    conversionCanceled:113007100,
    conversionComplete:113001300,
    conversionEnqueue:113001100,
    conversionError:113001000,
    conversionHeartBeating:113007800,
    courseAccessDisabled:113017100,
    courseArchived:113002800,
    courseArchiveEmailSent:113004600,
    courseAssetDownload: 113050200,
    courseComplete:113003400,
    courseCompletionDeadlineExpired:113016500,
    courseCopied:113041080,
    courseDeleted:113005600,
    courseDescriptionChanged:113005900,
    courseDetailsChanged: 113050100,
    courseEnroll:113003200,
    courseExportedFromMarketplaceToTMS:113041090,
    courseFrameArrangeChanged:113006200,
    courseGroupCreate:113012200,
    courseGroupDelete:113012300,
    courseInvite:113003100,
    courseMadeLive:113002500,
    courseNameChanged:113005700,
    coursePassingRequirementsChanged:113022600,
    coursePriceChanged:113019900,
    coursePublicPageEnableChanged:113006100,
    coursePurchase:113017000,
    coursePurchaseConfirmationEmailSent:113018200,
    courseReferenceDeleted:113016800,
    courseReinvite:113016100,
    courseRetaken:113005000,
    courseSaveAndClose:113012000,
    courseSettingsChanged:113006000,
    courseShareMCDEmailMarketplace:113024000,
    courseShareMCDFacebookMarketplace:113024100,
    courseShareMCDLinkedinMarketplace:113024300,
    courseShareMCDTwitterMarketplace:113024200,
    courseShareMCDYammerMarkeplace:113024350,
    courseShareMCPEmail:113022700,
    courseShareMCPFacebook:113022800,
    courseShareMCPLinkedin:113023000,
    courseShareMCPTwitter:113022900,
    courseShareOCDEmail:113024400,
    courseShareOCDFacebook:113024500,
    courseShareOCDLinkedin:113024700,
    courseShareOCDTwitter:113024600,
    courseShareOCDYammer:113024750,
    courseStart:113003300,
    courseStartByExpired:113008500,
    courseStateReset:113004300,
    courseTraineeAdded:113004900,
    courseTraineeReportsButtonClicked:113013100,
    courseTrainerImageUploaded: 113050000,
    courseTrainerInfoChanged:113005800,
    courseUnArchived:113047400,
    courseUnEnroll:113003600,
    courseUnInvite:113003500,
    courseWasInFolderAtTimeOfInvite:113012700,
    courseWasInSeriesAtTimeOfInvite:113027000,
    createAccount:113001500,
    createCatalog: 113049900,
    createContentFile:113000600,
    createCourse:113000300,
    createCourseReference:113016700,
    createFrame:113001400,
    createSeries:113028000,
    createTrainee:113004800,
    createTrainer:113003000,
    crocodocBlocked:113046600,
    customCertDownloadPDFPreview:113044700,
    customCertDownloadTemplate:113044600,
    customDomainChanged:113044300,
    customerNotificationEmail_Daily:113020200,
    customerNotificationEmail_Instantly:113020100,
    customerNotificationEmail_Monthly:113020400,
    customerNotificationEmail_Weekly:113020300,
    customizeTabClicked:113035200,
    customUserFieldNameChanged:113023100,
    deleteCatalog: 113050400,
    deleteContentFile:113001900,
    deleteFrame:113001800,
    deleteRecordedAudio:113035850,
    deleteSeries:113028200,
    deleteTrainer:113004400,
    deletingFrameStateOnInviteTraineeToCourse:113044000,
    deletingFrameStateOnTraineeRetake:113044100,
    deletingFrameStateOnTrainerReinvite:113044200,
    deletingFrameStateOnUninviteTrainee:113043900,
    deletingFrameStatesOnReplaceConversion:113043800,
    distributeTabClicked:113035300,
    domainChanged:113007300,
    domainDeleted:113014000,
    editAccountData:113001600,
    editContentFileData:113000700,
    editCourseData:113000200,
    editFrameData:113000500,
    editGroup:113049600,
    editSeries:113028100,
    enrollmentClosed:113002700,
    enrollmentDeadlineEnabledChanged:113002601,
    enrollmentDeadlineUpdated:113002600,
    enrollmentEmailResponded:113004100,
    enrollmentEmailSent:113004000,
    enrollmentReOpened:113005300,
    expireTrialPopupClosed:113033800,
    expireTrialPopupShown:113033900,
    fileUploadWasUnsuccessful:113002300,
    fireRemindAllService:113008150,
    forceRetakeByTrainer:113021000,
    forceRetakeByTrainerEmailSent:113021100,
    forgotPasswordEmailSent:113004700,
    freeConsultationRequestSubmitted:113030000,
    freeNavigationDisabled:113013800,
    freeNavigationEnabled:113013700,
    getStarted:113032000,
    getStartedBuildingCourseLoader:113032500,
    getStartedCongrats:113032600,
    getStartedCongratsGoToOCD:113032800,
    getStartedCongratsPreview:113032700,
    getStartedConversionErrorAskFileUsage:113033100,
    getStartedConversionErrorGeneric:113033000,
    getStartedConversionFailedGoToOCD:113032900,
    getStartedFindFile:113032100,
    getStartedIOSDevice:113033500,
    getStartedNoFlash:113033400,
    getStartedSkipToHome:113032400,
    getStartedTour:113032200,
    getStartedUploadErrorGeneric:113033300,
    getStartedUploadSuccessful:113033200,
    getStartedUseSampleCourse:113032300,
    gettingStarted:113030500,
    gettingStartedBuildingCourseLoader:113031000,
    gettingStartedCongrats:113031100,
    gettingStartedCongratsGoToOCD:113031300,
    gettingStartedCongratsPreview:113031200,
    gettingStartedFindFile:113030600,
    gettingStartedScheduleDemo:113048900,
    gettingStartedSkipToHome:113030900,
    gettingStartedTour:113030700,
    gettingStartedTourCreatePage:113048000,
    gettingStartedTourDistributePage:113048100,
    gettingStartedTourStartPage:113047900,
    gettingStartedTourTrackPage:113048200,
    gettingStartedUseSampleCourse:113030800,
    gOCDRightRailVideoClicked:113034000,
    goodDataFilterCreated:113042310,
    goodDataUserCreated:113042320,
    handoutDownload:113011700,
    handoutUpload:113011800,
    helpLinkClicked:113029000,
    hideAdvancedTierTrial:113043000,
    homePageTourVideoClicked:113031400,
    invitationEmailResent:113016200,
    invitationEmailSent:113003700,
    inviteEmailResponded:113003800,
    inviteTraineeToCourseGroup:113012600,
    inviteTraineeToSeries:113026000,
    iPadConversionCompletedSuccessfully:113041060,
    iPadConversionFailed:113041070,
    keynotePowerpointUploadAttempt:113042100,
    leadConvertedToPaid:113014500,
    leadConvertedToTrial:113013000,
    loaderComplete:113018500,
    loaderHTTPStatus:113018800,
    loaderIOError:113018600,
    loaderNullMarketingSwf:113019000,
    loaderOpen:113018900,
    loaderProgress:113016000,
    loaderSecurityError:113018700,
    loaderStart:113018400,
    managerInvitationEmailSent:113042600,
    manageTabClicked:113035000,
    markedTraineeCompleted:113048600,
    massEditUserCustomFields:113043500,
    massEditUserGroup:113049500,
    massEditUserGroupMembership:113043400,
    maximumQuestionsPerQuizReached:113016600,
    missingFilesWereUploaded:113005100,
    modifiedCourseLanguageSetting:113046000,
    modifiedSensionUsageSetting:113043700,
    navigateNext:113010800,
    navigatePrevious:113045700,
    noVideoTech:113046400,
    pARightRailSliderClicked:113038000,
    paymentInfoNextButtonPressed:113019300,
    payPalEmailChanged:113018300,
    pickPlanContinueClicked:113031600,
    pickPlanLightboxOpened:113031500,
    playRecordedAudio:113035700,
    pokeReminderEmailSent:113008100,
    previewCourse:113007900,
    previewCourseAsUser: 113050600,
    previewCourseInvoked:113008000,
    previewVideoDemoCourseClosed:113025100,
    previewVideoDemoCourseOpened:113025000,
    promoCodeApplied:113033700,
    promoCodeSaved:113033600,
    publicCoursePageHit:113002200,
    publishCourse:113001700,
    purchaseAccountNotificationEmailSent:113014600,
    purchaseCourseFailure:113019200,
    purchaseCourseSuccess:113019100,
    questionSentToTrainer:113019800,
    queueStatusUpdated:113007200,
    quizAdded:113006700,
    quizDataChanged:113006900,
    quizDeleted:113006800,
    quizQuestionAdded:113006300,
    quizQuestionAnswerDataChanged:113006600,
    quizQuestionDataChanged:113006500,
    quizQuestionDeleted:113006400,
    quizReportOpened:113014700,
    quizSettingsChanged:113007000,
    reactivateUser:113043200,
    recordAudio:113035650,
    reminderEmailSent:113003900,
    reminderEmailSkipped:113007500,
    removeContentFileFromCourse:113002100,
    replaceContentFile:113002000,
    reportsDownload:113035500,
    restrictedUserAdditionAttempted:113044500,
    rightRailFAQClicked:113034600,
    rollbackIpadConversion:113041050,
    sampleCourseCopied:113041100,
    sampleCourseInstalled:113034200,
    sampleTemplateDownloaded:113034300,
    saveRecordedAudio:113035900,
    sellerAccountInfoChanged:113021200,
    sentCatalogUpdateEmail:113047700,
    seriesCompletion:113003507,
    seriesCourseCompletion:113003508,
    seriesCourseInvite:113003504,
    seriesCoursePokeRemind:113003510,
    seriesCourseRearranged: 113048800,
    seriesCourseReinvite:113003511,
    seriesCourseRemind:113003506,
    seriesCourseUnInvite:113003502,
    seriesInvite:113003503,
    seriesPokeRemind:113003509,
    seriesReInvite:113003512,
    seriesRemind:113003505,
    seriesUnInvite:113003501,
    seriesUpdate:113048500,
    setAccountOwner:113047000,
    setTraineeCourseScore:113048700,
    shareMarketplaceCourse:113036000,
    shopifyFulfillmentFailed:113045500,
    shopifyFulfillmentReceived:113045300,
    shopifyFulfillmentSucceeded:113045400,
    shopifyInstalled:113044800,
    shopifyProductDeListed:113045100,
    shopifyProductListed:113045000,
    shopifyProductModified:113045200,
    shopifyUninstalled:113044900,
    sMEInvitationEmailSent:113008300,
    startDeadlineEnabledChanged:113008401,
    startDeadlineUpdated:113008400,
    startIpadConversion:113041000,
    startTierUpgradeTrial:113042800,
    stopPlayingAudio:113035800,
    stopRecordingAudio:113035750,
    subscribeLinkClicked:113030200,
    subscribePageLoaded:113030400,
    subscribeRedirectAfterLogin:113030300,
    surveyAdded:113023600,
    surveyDataChanged:113023800,
    surveyDeleted:113023700,
    surveyQuestionAdded:113023200,
    surveyQuestionAnswerDataChanged:113023500,
    surveyQuestionDataChanged:113023400,
    surveyQuestionDeleted:113023300,
    surveyReportExcelDownload:113024900,
    surveyReportView:113024800,
    surveySettingsChanged:113023900,
    switchingWelcomePopupMarketplaceClick:113022400,
    switchingWelcomePopupTMSClick:113022500,
    thereAreMissingFiles:113002400,
    trackTabClicked:113035400,
    traineeAppLoaded:113012940,
    traineeAppLoading:113012920,
    traineeCertificateDeleted: 113047100,
    traineeCourseLastPageCertificateView:113011100,
    traineeCourseView:113008200,
    traineeDashboardCertificateView:113011200,
    traineeEmailCertificateView:113011300,
    traineeEnrolled:113005400,
    traineeEnterFullScreen:113013200,
    traineeExitFullScreen:113013300,
    traineeNotificationEmail_DailySent:113014200,
    traineeNotificationEmail_InstantlySent:113014100,
    traineeNotificationEmail_MonthlySent:113014400,
    traineeNotificationEmail_WeeklySent:113014300,
    traineeNotificationSelected_Daily:113015200,
    traineeNotificationSelected_Instantly:113015100,
    traineeNotificationSelected_Monthly:113015400,
    traineeNotificationSelected_Off:113015000,
    traineeNotificationSelected_Weekly:113015300,
    traineeRegistered:113005200,
    traineesCapacityWarning:113009000,
    traineeSelfRegistration:113011900,
    traineeSeriesDeadlineUpdated:113043300,
    traineeUnEnrolled:113005500,
    trainerAppLoaded:113012840,
    trainerAppLoading:113012820,
    trainerCertificatePreview:113011400,
    trainerCourseCompletionEmailPreviewCerificateView:113011600,
    trainerFeedbackSent:113042900,
    trainerInvitationEmailSent:113003750,
    trainerOCDCertificateView:113011410,
    trainerPreviewCourseLastPageCertificateView:113011500,
    trainerSeriesDashboardCertificateView:113011420,
    trialCreationNotificationEmailSent:113007400,
    unEnrollmentEmailSent:113004200,
    updatedGoodDataCustomUrls:113047600,
    upgradeAccountCanceled:113010500,
    upgradeAccountClicked:113010700,
    uploadBegin:113000800,
    uploadCanceled:113030100,
    uploadComplete:113000900,
    uploadFileTooBig:113045600,
    userPermissionsChangedToAdministrator:113039000,
    userPermissionsChangedToManager:113042500,
    userPermissionsChangedToReporter:113047200,
    userPermissionsChangedToTeamLead:113047200,
    userPermissionsChangedToTrainee:113040000,
    userPermissionsChangedToTrainer:113042400,
    usersPromotedToAdminsOnSignUpDueLackOfTheFeature:113043600,
    videoPlaybackError:113046800,
    videoPluginBlocked:113046500,
    viewCourseData:113000100,
    viewGoodDataCourseReportClicked:113042200,
    viewGoodDataDashboardClicked:113042300,
    viewGoodDataSeriesReportClicked:113042210,
    viewedManageUsers:113048400,
    viewReportClicked:113034100,
    viewedTrainerDashboard:113048300,
    welcomeEmailToBuyerSent:113018100,
    welcomePopupCloseClick:113022100,
    welcomePopupMarketplaceClick:113022200,
    welcomePopupTMSClick:113022300,
    yammerAccountSettingChanged:113037000,
    youTubeBlocked:113046700,
    youTubeVideoReplaced:113012500,
    youTubeVideoUploaded:113012400,
    zuoraSubscriptionBilled:113042000
  },
  billingIntervalType: {
    none:0,
    annual:165000200,
    annualInvoiced:165000300,
    monthly:165000100
  },
  brandingColorScheme: {
    none:0,
    blue:102000100,
    green:102000200,
    orange:102000300
  },
  catalogAccessType: {
    none:0,
    catalogNotShared:175000100,
    catalogShared:175000200
  },
  catalogTraineeAccessType: {
    none: 0,
    allTrainees: 178000100,
    groups: 178000200
  },
  certificateQuizStatus: {
    none:0,
    off:132000200,
    on:132000100
  },
  certificateStatus: {
    none:0,
    afterCoursesOnly:129000500,
    afterSeriesAndCourses:129000300,
    afterSeriesOnly:129000400,
    off:129000200,
    on:129000100
  },
  certificateTemplate: {
    none:0,
    custom:130000400,
    template1:130000100,
    template2:130000200,
    template3:130000300
  },
  commissionPaymentStatus: {
    none:0,
    beginMassPayTransaction:143000300,
    failed:143000200,
    manualPayRequested:143000600,
    succeeded:143000100,
    waitingForClaim:143000500,
    waitingForNotification:143000400
  },
  contentFileDisplayMode: {
    none:0,
    ghettoS3Bucket:104000100,
    newS3Bucket:104000200
  },
  contentFileMetadataEntry: {
    none:0,
    animatedGifs:103002800,
    audioName:103005700,
    audioWithNarrationName:103006300,
    containsImageInsteadOfVideo:103005800,
    contentLength:103003200,
    conversionError:103001100,
    conversionErrorTitle:103002700,
    conversionGoToMeetingError:103003900,
    conversionProgress:103001000,
    conversionStatus:103001300,
    conversionWarning:103001200,
    crocodocID:103004900,
    deprecatedThumbnailName:103000800,
    displayTitle:103006900,
    editedImageScale:103002350,
    editorHeight:103002200,
    editorImageName:103002400,
    editorScale:103002300,
    editorWidth:103002100,
    editorX:103001900,
    editorY:103002000,
    hasAudio:103001500,
    height:103000100,
    hideWhileNotPlaying:103002600,
    highQuality1stImage:103001700,
    hyperlinks:103003300,
    largeThumbnailName:103002900,
    mobileConversionOriginalFileID:103005000,
    originalFileName:103001800,
    permissionToInvestigateError:103004600,
    pptImageJpgContentLength:103007200,
    pptImageJpgContentPath:103007100,
    replacedByFileId:103004700,
    replacedFile:103001600,
    rotation:103000500,
    s3MultiPartUploadId:103006800,
    sequencePoints:103001400,
    smallThumbnailName:103003000,
    swfCacheFileName:103003100,
    thumbnailHeight:103000600,
    thumbnailWidth:103000700,
    uploadToken:103000900,
    useVideoFromImageAndAudioConversion:103006700,
    videoAverageFps:103004300,
    videoConversionTime:103004500,
    videoEncodingParams:103004100,
    videoHDWithNarrationName:103005900,
    videoHLSFileNames:103006500,
    videoHLSFileNamesNarration:103006600,
    videoHLSPlaylistName:103004800,
    videoHLSPlaylistWithNarrationName:103006400,
    videoKeyFrames:103004200,
    videoLength:103004000,
    videoLowQualityHeight:103005300,
    videoLowQualityName:103005100,
    videoLowQualityWidth:103005200,
    videoLowQualityWithNarrationName:103006100,
    videoMinimumFps:103004400,
    videoOriginalHeight:103003600,
    videoOriginalWidth:103003500,
    videoSDHeight:103003800,
    videoSDName:103003400,
    videoSDWidth:103003700,
    videoSDWithNarrationName:103006000,
    videoVeryLowQualityHeight:103005600,
    videoVeryLowQualityName:103005400,
    videoVeryLowQualityWidth:103005500,
    videoVeryLowQualityWithNarrationName:103006200,
    width:103000200,
    x:103000300,
    y:103000400,
    z:103002500
  },
  contentFileStatus: {
    none:0,
    conversionError:101001100,
    converted:101000900,
    converting:101000700,
    courseDeleted:101001200,
    delayedDeletionPending:101001300,
    deleted:101001400,
    dequeued:101000600,
    exists:101000400,
    inQueue:101000500,
    invalid:101001000,
    missing:101000100,
    missingContent:101000200,
    paused:101000800,
    uploading:101000300
  },
  contentFileType: {
    none:0,
    animGif:100001600,
    audio:100000600,
    compositeThumb:100003400,
    courseReport:100002700,
    customCertificateBackground:100003600,
    excel:100002500,
    excelUserImport:100002550,
    gTMVideo:100003200,
    html:100000300,
    image:100000700,
    launchFile:100002400,
    mobileConversion:100003500,
    narrationAudio:100003300,
    other:100000100,
    pDF:100001700,
    pdfPage:100001800,
    ppt:100000500,
    pptImageSlide:100003100,
    pptSlide:100001300,
    pptVideoPresentation:100002800,
    pptVideoSlide:100002900,
    pptVideoSlideSourcePptx:100003000,
    rar:100002100,
    rss:100001200,
    sCORMPackage:100002300,
    swf:100000900,
    system:100001900,
    text:100001500,
    torrent:100002200,
    unsupported:100000200,
    video:100000800,
    word:100000400,
    wordPage:100001400,
    xml:100001100,
    youTubeVideo:100002600,
    zip:100002000
  },
  conversionErrorType: {
    none:0,
    general:144000100,
    goToMeetingUnsupportedCodec:144000200
  },
  conversionQueueItemStatus: {
    none:0,
    deleted:111000500,
    dequeued:111000200,
    done:111000400,
    error:111000700,
    processing:111000300,
    queued:111000100,
    timedOut:111000600
  },
  conversionQueueItemType: {
    none:0,
    narrationConversion:112000500,
    newConversion:112000100,
    newSupportingFileConversion:112000300,
    replaceConversion:112000200,
    supportingFileReplaceConversion:112000400
  },
  courseAccessType: {
    none:0,
    existingUserSelfRegister:133000400,
    noRegister:133000200,
    publicSelfRegister:133000300,
    teamMemberInviteOnly:133000100
  },
  courseAssetType: {
    none:0,
    handout:128000100
  },
  courseDeadlineUnit: {
    none:0,
    day:137000100,
    week:137000200
  },
  courseGroupType: {
    none:0,
    default_:147000100,
    sequenced:147000200
  },
  coursePurchaseStatus: {
    none:0,
    commissionFailed:141000500,
    commissionPending:141000400,
    commissionSuccess:141000600,
    paymentFailed:141000200,
    paymentInProgress:141000150,
    paymentPending:141000100,
    paymentSuccess:141000300
  },
  courseSearchTypeKind: {
    none:0,
    category:161000100,
    tag:161000200
  },
  courseStateStatus: {
    none:0,
    completed:116000300,
    enrolled:116000100,
    invited:116000050,
    missedCompletionDeadline:116000600,
    started:116000200,
    unEnrolled:116000500,
    unInvited:116000400
  },
  courseStatus: {
    none:0,
    active:107000200,
    archive:107000300,
    draft:107000100
  },
  courseType: {
    none:0,
    demo:106000200,
    live:106000500,
    online:106000100,
    readOnlyDemo:106000300,
    series:106000400
  },
  customCertificateField: {
    none:0,
    blank:176000100,
    companyName:176000400,
    completionDate:176000300,
    courseName:176000500,
    courseScore:176000600,
    customField:176000800,
    textField:176000700,
    traineeName:176000200,
    trainerName:176000900
  },
  domainRecordType: {
    none:0,
    custom:145000300,
    primary:145000100,
    secondary:145000200
  },
  emailTemplateType: {
    none:0,
    completion:120000300,
    enrollment:120000200,
    invitation:120000100,
    reminder:120000400,
    seriesCompletion:120000700,
    seriesInvitation:120000500,
    seriesReminder:120000600
  },
  entityType: {
    none:0,
    account:110000100,
    actionLog:110000800,
    catalog:110004300,
    contentFile:110000500,
    contentFileMetadata:110001300,
    contentFilePage:110002400,
    conversionQueueItem:110000600,
    course:110000300,
    courseAsset:110003000,
    courseGroup:110003200,
    courseGroupCourse:110003300,
    coursePurchase:110003900,
    courseState:110001000,
    courseStateArchive:110002700,
    domain:110000900,
    emailTemplateItem:110002500,
    forgotPasswordRequest:110002600,
    frame:110000400,
    frameState:110001100,
    liveCourse: 110004500,
    question:110001500,
    questionEssay:110004100,
    questionImageCaption:110002000,
    questionImageCaptionEntry:110002100,
    questionImageParts:110002200,
    questionImagePartsEntry:110002300,
    questionMultipleChoice:110001600,
    questionMultipleChoiceEntry:110001700,
    questionMultipleCorrect:110003500,
    questionMultipleCorrectEntry:110003600,
    questionSequence:110001800,
    questionSequenceEntry:110001900,
    questionTrueFalse:110003700,
    questionTrueFalseEntry:110003800,
    quiz:110001400,
    sellerPayment:110004000,
    series:110004200,
    sess:110001200,
    style:110000700,
    traineeCertificate:110003100,
    user:110000200,
    userGroup:110002800,
    userGroupUser:110002900,
    userSetting:110003400
  },
  featureEntry: {
    none:0,
    api:168001100,
    catalogMontara: 168004000,
    contentTabArranger: 168004800,
    courseCatalog:168002000,
    coursesMontara: 168003800,
    customBranding:168002200,
    customCertificate:168002300,
    customDomain:168001500,
    durationTracking:168000700,
    excludeArchiveReport: 168002900,
    fastForwardControl: 168002800,
    goodDataDashboardHeavy:168000400,
    goodDataDashboardLight:168000300,
    hideMindflashBranding: 168004600,
    inviteV2: 168006600,
    leftMenuMontara: 168003900,
    liveTraining:168003200,
    localization:168002500,
    manageUsersMontara:168003300,
    massTraineeActions:168000800,
    mmReportCertificateGeneration: 168008200,
    multipleCustomFields:168001000,
    multipleTrainers:168000500,
    newCourseInviteRoutes:168003100,
    newPlayerProgress:168002600,
    newPlayerLoad:168002700,
    newSeries:168003000,
    newUserManagement:168000900,
    sAML:168001400,
    sCORM:168002100,
    sension:168001300,
    series:168000100,
    seriesMontara: 168003700,
    shopify:168002400,
    traineeHomeHtml:168001800,
    traineePlayerHtml:168001700,
    trainerHTMLHome:168001600,
    trainerPermissions:168000200,
    userMgmtRestrictions:168001900,
    usernameLogin:168001200,
    yammer:168000600
  },
  featureTierStatus: {
    none:0,
    active:166000100,
    retired:166000200
  },
  fileStorageProvider: {
    none:0,
    amazonS3:131000200,
    internalNetworkPath:131000100,
    youTube:131000300
  },
  frameResizeType: {
    none:0,
    originalSize:114000400,
    scaleToFit:114000100,
    scrollHorizontally:114000300,
    scrollVertically:114000200,
    stretchToFit:114000500
  },
  frameStateStatus: {
    none:0,
    completed:117000200,
    started:117000100
  },
  frameTransitionType: {
    none:0,
    fade:115000200,
    slide:115000300,
    wipe:115000100
  },
  frameType: {
    none:0,
    file:108000100,
    firstFrame:108000200,
    lastFrame:108000600,
    question:108000300,
    quizFirstFrame:108000400,
    quizLastFrame:108000500,
    sCOFrame:108001100,
    sCOQuizFrame:108001000,
    surveyIntroFrame:108000700,
    surveyLastFrame:108000900,
    surveyQuestionFrame:108000800
  },
  gradeStatus: {
    none:0,
    failed:125000300,
    notApplicable:125000100,
    passed:125000200
  },
  loginMode: {
    none:0,
    email:172000100,
    username:172000200
  },
  messageSettingArea: {
    none:0,
    account_Profile_Trainer_Info:150000300,
    expire_Trial_Popup_Duration_Days:150000600,
    expire_Trial_Popup_Header:150000400,
    expire_Trial_Popup_Sub_Header:150000500,
    my_Courses_Manage_Account_Module:150000200,
    my_Courses_Top_Product_Update_Customers_Text:150000800,
    my_Courses_Top_Product_Update_Trialists_Text:150000700,
    my_Courses_Top_Trial_Banner_Text1:150000100,
    my_Courses_Top_Trial_Banner_Text1_Intro:150000120,
    my_Courses_Top_Trial_Banner_Text2:150000110,
    my_Courses_Top_Trial_Banner_Text2_Intro:150000130
  },
  messageSettingPeriod: {
    none:0,
    advancedTierTrial:160000400,
    always:160000500,
    entireMonth:160000300,
    firstTrialHalf:160000100,
    lastTrialHalf:160000200
  },
  mindflashExceptionCode: {
    none:0,
    accountIsDisabled:121101700,
    actionNotAllowed:121105500,
    alternateEmailIsInvalid:121105400,
    authenticationError:121000100,
    billingAddress1Error:121103700,
    billingAddress2Error:121103800,
    billingAddressRequired:121103000,
    billingCityError:121103900,
    billingCityRequired:121103100,
    billingCountryCodeError:121104200,
    billingPhoneError:121104300,
    billingPostalCodeError:121104100,
    billingPostalCodeRequired:121103300,
    billingStateError:121104000,
    billingStateRequired:121103200,
    cantSignUpMultipleTrialsWithTheSameEmail:121101300,
    cardExpirationMonthOutOfRange:121102800,
    cardExpirationYearOutOfRange:121102900,
    cardHolderNameRequired:121102500,
    cardNumberRequired:121102600,
    cardSecurityCodeRequired:121105200,
    cardTypeRequired:121102700,
    cardTypeUnrecognized:121105100,
    countryCodeRequired:121103600,
    courseAlreadyActivatedError:121105900,
    courseNotFoundOrNotPublic:121102400,
    creditCardExpirationMonthError:121104600,
    creditCardExpirationYearError:121104700,
    creditCardHolderNameError:121104800,
    creditCardNumberError:121104500,
    creditCardSecurityCodeError:121104900,
    creditCardTypeError:121104400,
    domainNameIsInvalid:121101100,
    emailIsInvalid:121101000,
    emailRequired:121101400,
    emailToLong:121100700,
    entityNotFound:121000200,
    fileUploadedForDeletedCourse:121102200,
    firstNameRequired:121100100,
    firstNameToLong:121100200,
    groupSizeRequired:121106300,
    intentRequired:121106400,
    invalidIDFormat:121102300,
    invalidPricingCode:121105300,
    lackOfPayment:121101900,
    lastNameRequired:121100300,
    lastNameToLong:121100400,
    loginRequired:121101500,
    marketplaceDisabled:121105600,
    multipleEntitiesFound:121000300,
    noAccountDataFound:121105700,
    noUserDataFound:121105800,
    numberOfTraineesToPurchaseDoesNotMatchTier:121103500,
    numberOfTraineesToPurchaseRequired:121103400,
    organizationNameRequired:121100500,
    passwordRequired:121100800,
    passwordsNotMatch:121100900,
    passwordToLong:121100600,
    passwordTooShort:121100650,
    phoneIsInvalid:121106100,
    phoneRequired:121106200,
    phoneTooLong:121106000,
    portalNameAlreadyInUse:121101200,
    purchaseAccountBillingError:121105000,
    questionAttemptLimitExceeded:121102000,
    resetQuestionAttemptLimitExceeded:121102100,
    sessionInvalid:121101800,
    userDoesNotExists:121101600,
    userIsArchived:121000400,
    userIsDeleted:121000500,
    yammerSSODisabled:121106600,
    yammerSSOFailed:121106500
  },
  mobileConversionState: {
    none:0,
    conversionError:164000500,
    converted:164000400,
    converting:164000300,
    notReady:164000100,
    ready:164000200
  },
  none: {
    none:0,
    none:0
  },
  paymentGateway: {
    none:0,
    cyberSource:142000100,
    paypal:142000200
  },
  pricingType: {
    none:0,
    free:126000200,
    pay:126000300,
    trial:126000100
  },
  productMembership: {
    none:0,
    all:16777219,
    marketplace:16777218,
    noProducts:16777216,
    tMS:16777217
  },
  productTestSuiteType: {
    none:0,
    onboarding:149000100
  },
  productType: {
    none:0,
    marketplace:140000200,
    tMS:140000100
  },
  questionType: {
    none:0,
    essay:118000900,
    firstPage:118000500,
    imageCaption:118000300,
    imageParts:118000400,
    lastPage:118000600,
    multipleChoice:118000100,
    multipleCorrect:118000700,
    sequence:118000200,
    trueFalse:118000800
  },
  quizType: {
    none:0,
    quiz:146000100,
    survey:146000200
  },
  reminderInterval: {
    none:0,
    fourWeeks:122000400,
    oneWeek:122000100,
    sixMonths:122000500,
    threeDays:122000010,
    threeWeeks:122000300,
    twoWeeks:122000200
  },
  sensionUsage: {
    none:0,
    measureEngagement:173000100,
    requireEngagement:173000200
  },
  seriesType: {
    none:0,
    default_:148000100,
    sequenceEnforced:148000200,
    courseFailureEnforced: 148000300
  },
  sessDeviceType: {
    none:0,
    ipad:174000200,
    web:174000100
  },
  sessStatus: {
    none:0,
    invalid:123000200,
    valid:123000100
  },
  sessType: {
    none:0,
    anonymous:124000300,
    sME:124000200,
    standard:124000100
  },
  singleSignOnType: {
    none:0,
    aPI:151000200,
    sAML:151000300,
    yammer:151000100
  },
  timeZone: {
    none:0,
    '(GMT-01:00) Azores':119009700,
    '(GMT-01:00) Cape Verde Is.':119009800,
    '(GMT-02:00) Mid-Atlantic':119009900,
    '(GMT-03:00) Brasilia':119010000,
    '(GMT-03:00) Buenos Aires':119010100,
    '(GMT-03:00) Cayenne':119010200,
    '(GMT-03:00) Greenland':119010300,
    '(GMT-03:00) Montevideo':119010400,
    '(GMT-03:30) Newfoundland':119010500,
    '(GMT-04:00) Asuncion':119010600,
    '(GMT-04:00) Atlantic Time':119000800,
    '(GMT-04:00) Georgetown':119010700,
    '(GMT-04:00) Manaus':119010800,
    '(GMT-04:00) San Juan':119010900,
    '(GMT-04:00) Santiago':119011000,
    '(GMT-04:30) Caracas':119011100,
    '(GMT-05:00) Bogota':119011200,
    '(GMT-05:00) Eastern Time ':119000700,
    '(GMT-05:00) Lima':119011300,
    '(GMT-05:00) Quito':119011400,
    '(GMT-06:00) Central America':119011500,
    '(GMT-06:00) Central Time':119000600,
    '(GMT-06:00) Guadalajara':119011600,
    '(GMT-06:00) Mexico City':119011700,
    '(GMT-06:00) Saskatchewan':119011800,
    '(GMT-07:00) Arizona':119000400,
    '(GMT-07:00) Chihuahua':119011900,
    '(GMT-07:00) Mazatlan':119012000,
    '(GMT-07:00) Mountain Time':119000500,
    '(GMT-08:00) Baja California':119012100,
    '(GMT-08:00) Pacific Time':119000300,
    '(GMT-09:00) Alaska':119000200,
    '(GMT-10:00) Hawaii':119000100,
    '(GMT-11:00) Midway Island':119012200,
    '(GMT-12:00) Intl. Date Line':119012300,
    '(GMT) Dublin':119001000,
    '(GMT) Greenwich Mean Time':119000900,
    '(GMT) Lisbon':119001100,
    '(GMT) London':119001200,
    '(GMT+01:00) Amsterdam':119001300,
    '(GMT+01:00) Belgrade':119001400,
    '(GMT+01:00) Berlin':119001500,
    '(GMT+01:00) Bratislava':119001600,
    '(GMT+01:00) Brussels':119001700,
    '(GMT+01:00) Budapest ':119001800,
    '(GMT+01:00) Central Africa':119003000,
    '(GMT+01:00) Copenhagen':119001900,
    '(GMT+01:00) Ljubljana':119002000,
    '(GMT+01:00) Madrid':119002100,
    '(GMT+01:00) Paris':119002200,
    '(GMT+01:00) Prague':119002300,
    '(GMT+01:00) Rome':119002400,
    '(GMT+01:00) Sarajevo':119002500,
    '(GMT+01:00) Skopje':119002600,
    '(GMT+01:00) Stockholm':119002700,
    '(GMT+01:00) Vienna':119002800,
    '(GMT+01:00) Warsaw':119002900,
    '(GMT+01:00) Zagreb':119003100,
    '(GMT+02:00) Amman':119003200,
    '(GMT+02:00) Athens':119003300,
    '(GMT+02:00) Beirut':119003400,
    '(GMT+02:00) Bucharest':119003500,
    '(GMT+02:00) Cairo':119003600,
    '(GMT+02:00) Harare':119003700,
    '(GMT+02:00) Helsinki':119003800,
    '(GMT+02:00) Istanbul':119003900,
    '(GMT+02:00) Jerusalem':119004000,
    '(GMT+02:00) Minsk':119004100,
    '(GMT+02:00) Pretoria':119004200,
    '(GMT+02:00) Riga':119004300,
    '(GMT+02:00) Sofia':119004400,
    '(GMT+02:00) Tallinn':119004500,
    '(GMT+02:00) Windhoek':119004600,
    '(GMT+03:00) Baghdad':119004700,
    '(GMT+03:00) Moscow':119004800,
    '(GMT+03:00) Nairobi':119004900,
    '(GMT+03:00) Riyadh':119005000,
    '(GMT+03:00) Tbilisi':119005100,
    '(GMT+03:30) Tehran':119005200,
    '(GMT+04:00) Abu Dhabi':119005300,
    '(GMT+04:00) Baku':119005400,
    '(GMT+04:00) Port Louis':119005600,
    '(GMT+04:00) Yerevan':119005700,
    '(GMT+04:30) Kabul':119005800,
    '(GMT+05:00) Ekaterinburg':119005900,
    '(GMT+05:00) Islamabad':119006000,
    '(GMT+05:00) Tashkent':119006100,
    '(GMT+05:30) Colombo':119006200,
    '(GMT+05:30) India Standard':119006300,
    '(GMT+05:45) Kathmandu':119006400,
    '(GMT+06:00) Almaty':119006500,
    '(GMT+06:00) Astana':119006600,
    '(GMT+06:30) Yangon (Rangoon)':119006700,
    '(GMT+07:00) Bangkok':119006800,
    '(GMT+07:00) Jakarta':119006900,
    '(GMT+07:00) Krasnoyarsk':119007000,
    '(GMT+08:00) Beijing':119007100,
    '(GMT+08:00) Hong Kong':119007200,
    '(GMT+08:00) Irkutsk':119007300,
    '(GMT+08:00) Kuala Lumpur':119007400,
    '(GMT+08:00) Perth':119007500,
    '(GMT+08:00) Singapore':119007600,
    '(GMT+08:00) Taipei':119007700,
    '(GMT+08:00) Ulaan Bataar':119007800,
    '(GMT+08:00) Urumqi':119007900,
    '(GMT+09:00) Osaka  ':119008000,
    '(GMT+09:00) Seoul':119008100,
    '(GMT+09:00) Tokyo':119008200,
    '(GMT+09:00) Yakutsk':119008300,
    '(GMT+09:30) Adelaide':119008400,
    '(GMT+09:30) Darwin':119008500,
    '(GMT+10:00) Brisbane':119008600,
    '(GMT+10:00) Guam':119008700,
    '(GMT+10:00) Hobart':119008800,
    '(GMT+10:00) Melbourne':119008900,
    '(GMT+10:00) Sydney':119009000,
    '(GMT+10:00) Vladivostok':119009100,
    '(GMT+11:00) New Caledonia':119009200,
    '(GMT+11:00) Solomon Is.':119009300,
    '(GMT+12:00) Auckland':119009400,
    '(GMT+12:00) Fiji':119009500
  },
  trainerNotificationEmailsPeriod: {
    none:0,
    daily:134000200,
    instantly:134000100,
    monthly:134000400,
    weekly:134000300
  },
  userBillingStatus: {
    none:0,
    billable:163000100,
    notBillable:163000200
  },
  userCustomFieldRequiredState: {
    none:0,
    optional:170000200,
    required:170000100
  },
  userCustomFieldVisbility: {
    none:0,
    accountOnly:171000100,
    notVisible:171000300,
    publicCoursePage:171000200
  },
  userPrivilege: {
    none: 0,
    canArchiveUsers:177000800,
    canDropTrainees:177000500,
    canEditCatalogs: 177001900,
    canEditCourses:177000300,
    canEditCustomFields:177001100,
    canEditGroupMembership:177001200,
    canEditGroups:177000900,
    canEditUserInfo:177001000,
    canExtendTraineeDeadlines:177000600,
    canInviteUsers:177000100,
    canMarkTraineeCompleted:177001600,
    canPreviewCourse:177001400,
    canRemindTrainees:177000700,
    canResetTrainees:177000400,
    canSetTraineeScore:177001700,
    canToggleCourseRequired:177001800,
    canUpdateTraineesInSeries:177001500,
    canViewCatalogs:177001300,
    canViewDraftCourses:177000200
  },
  userRole: {
    none:0,
    administrator:169000400,
    manager:169000200,
    reporter:169000500,
    teamLead:169000600,
    trainee:169000100,
    trainer:169000300
  },
  userSettingsEntry: {
    none:0,
    expireTrialPopup:136001100,
    homePage:136000900,
    manageUsersCoursesTabCourseStateFilter:136001600,
    manageUsersCoursesTabGrid:136001400,
    manageUsersGrid:136001300,
    manageUsersSeriesTabCourseStateFilter:136001700,
    manageUsersSeriesTabDrilldownGrid:136001800,
    manageUsersSeriesTabGrid:136001500,
    marketplaceDashboardFilter:136000800,
    marketplaceDashboardSortAscending:136000600,
    marketplaceDashboardSortField:136000500,
    marketplaceDashboardView:136000700,
    pARightRailShown:136001200,
    trainerDashboardFilter:136000400,
    trainerDashboardSortAscending:136000200,
    trainerDashboardSortField:136000100,
    trainerDashboardView:136000300,
    trainerInfo: 136002100,
    trainOrSellPopup:136001000
  },
  userSettingsGroup: {
    none:0,
    manageSeries: 135000300,
    manageUsers:135000200,
    manageCatalog : 135000500,
    trainerDashboard:135000100
  },
  userStatus: {
    none:0,
    active:109000200,
    archived:109000700,
    banned:109000500,
    inactive:109000400,
    loggedIn:109000300,
    removeable:109000600,
    visitor:109000100
  },
  yammerNetworkType: {
    none:0,
    external:162000200,
    primary:162000100
  }
});
